<template lang="html">
  <div>
    <page-header :heading="'View your scans'" />
    <main>
      <div class="wrapper">
        <!-- Replace with your content -->
        <div class="text-center py-12" v-if="loading">
          <svg
            class="inline-block animate-spin -ml-1 mr-1 h-5 w-5 text-gray-500"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          Loading
        </div>
        <div class="-mt-16 relative" v-else>
          <div
            class="animate-pulse w-full text-white text-sm text-center absolute -top-10"
            v-if="$parent.scansInProgress"
          >
            {{ $parent.scansInProgress }} scan<span
              v-if="$parent.scansInProgress > 1"
              >s</span
            >
            currently in progress
          </div>
          <transition-group
            name="list-complete"
            class="md:flex md:flex-wrap wrapper justify-center"
            tag="ul"
          >
            <li
              class="block md:w-1/3 xl:w-1/4 px-3 mb-8"
              v-for="(scan, index) in scans"
              :key="scan.id"
            >
              <div
                class="flex flex-col bg-white rounded-md shadow-md mb-1 h-full"
                :to="{ name: 'Scan', params: { id: scan.id } }"
              >
                <img
                  class="max-w-full h-48 object-cover object-top overflow-hidden rounded-md shadow-md"
                  :src="scan.url"
                />
                <div class="flex flex-wrap p-4 justify-between">
                  <h3
                    class="w-full whitespace-nowrap overflow-hidden text-sm leading-tight"
                  >
                    {{ scan.name }}
                  </h3>
                  <p class="font-bold text-xs w-full mb-4">
                    {{ scanCreated(scan.createdAt) }}
                  </p>
                  <router-link
                    :to="{ name: 'Scan', params: { id: scan.id } }"
                    class="mt-2 px-2 py-2 text-white rounded bg-secondary border-secondary border-2 text-xs shadow"
                    @click="updateItem(scan)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      class="w-4 h-4"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                      />
                    </svg>
                  </router-link>
                  <button
                    class="mt-2 px-2 py-2 text-red-500 rounded bg-white border-red-500 border-2 text-xs shadow"
                    @click="deleteItem(scan, index)"
                    v-if="user.attributes['custom:stripe_plan_name']"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      class="w-4 h-4"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </li>
          </transition-group>
        </div>
        <!-- /End replace -->
      </div>
    </main>
  </div>
</template>

<script>
import { Auth, API, Analytics } from "aws-amplify";
import moment from "moment";
import PageHeader from "@/components/PageHeader";

export default {
  name: "Scans",
  components: {
    PageHeader,
  },
  data() {
    return {
      user: null,
      scans: null,
      loading: false,
    };
  },
  methods: {
    async fetchData() {
      this.loading = true;
      const user = await Auth.currentAuthenticatedUser();
      this.user = user;
      const token = user.signInUserSession.idToken.jwtToken;

      const request = {
        body: {
          attr: "value",
        },
        headers: {
          Authorization: token,
        },
      };

      API.get("scans", "/scans", request)
        .then((result) => {
          result.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
          this.scans = result;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    scanCreated(time) {
      return moment(time).fromNow();
    },
    async deleteItem(scan, index) {
      const user = await Auth.currentAuthenticatedUser();
      const token = user.signInUserSession.idToken.jwtToken;
      let vm = this;
      if (
        confirm(
          "Are you sure you want to delete this scan? This can not be undone"
        )
      ) {
        API.del("scans", `/scans/${scan.id}`, {
          headers: {
            Authorization: token,
          },
        })
          .then(() => {
            vm.$delete(this.scans, index);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
  watch: {
    // call again the method if the route changes
    $route: "fetchData",
    "$parent.scansInProgress": "fetchData",
  },
  created() {
    // client request: fetching todos
    this.fetchData();
    Analytics.record({ name: "viewedScans" });
  },
};
</script>

<style lang="css">
.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
